export const SUPABASE_PROJECT_REF = 'urtmleicijluwonalidr';
export const EDGE_EMAIL_URL = `https://${SUPABASE_PROJECT_REF}.supabase.co/functions/v1/rapid-service`;
export const BASE_URL = typeof window !== 'undefined' ? window.location.origin : '';
export const EMAIL_FROM = 'Serhan Kombos Otomotiv <noreply@kombosdms.com>';
export const LOGO_URL = `https://${SUPABASE_PROJECT_REF}.supabase.co/storage/v1/object/public/logos/merclogo.webp`;
